export default __webpack_public_path__ + "static/media/c.d5e8b602.jpg";